export const name = "SOUNDEX";
export const summary = `Gets the Soundex codes for words in a \`STRING\` value.`;
export const reference = `
## SOUNDEX

Gets the Soundex codes for words in a \`STRING\` value.

\`\`\`
SOUNDEX(value)
\`\`\`

### Description

Returns a \`STRING\` that represents the Soundex code for \`value\`.

SOUNDEX produces a phonetic representation of a string. It indexes words by sound, as pronounced in English. It's typically used to help determine whether two strings, such as the family names _Levine_ and _Lavine_, or the words _to_and _too_, have similar English-language pronunciation.

The result of the SOUNDEX consists of a letter followed by 3 digits. Non-latin characters are ignored. If the remaining string is empty after removing non-Latin characters, an empty \`STRING\` is returned.


### Return type

\`STRING\`


### Examples



\`\`\`
SELECT 'Ashcraft' AS value, SOUNDEX('Ashcraft') AS soundex

/*----------------------+---------*
 | value | soundex |
 +----------------------+---------+
 | Ashcraft | A261 |
 *----------------------+---------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/string_functions
`;
